module.exports = __webpack_public_path__ + "img/ai2.45ac85ec.png";